/**
 * Client helper for CRM marketing preferences HttpOnly cookie (CRM-018).
 * Cookie is set/cleared by the server; the browser cannot modify it directly.
 */

import {fetchWithTimeout} from '@amblique/king-living/app/utils/fetch-with-timeout';

/**
 * Ask the server to clear the HttpOnly CRM preferences cookie(s) on logout.
 *
 * @returns {Promise<void>}
 */
export async function clearCrmPreferencesCookie() {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    await fetchWithTimeout('/api/crm/preferences/cookie/clear', {
      method: 'POST',
      credentials: 'include',
    });
  } catch {
    // Fail-soft: logout must not be blocked by cookie cleanup
  }
}
